"use client";

import { IsLoggedIn } from "@/components/shared/is-logged-in";
import { UserDropdown } from "@/components/shared/user-dropdown";
import { cn } from "@/utils/lib";

type AppLayoutUserMenuProps = {
  align?: "left" | "right";
};

export const AppLayoutUserMenu = ({
  align = "left",
}: AppLayoutUserMenuProps) => {
  return (
    <div
      className={cn("flex w-full items-center gap-2", {
        "justify-start": align === "left",
        "justify-end": align === "right",
      })}
    >
      <div className="flex w-full items-center gap-3">
        <div
          className={cn("w-full", {
            "order-1": align === "left",
            "order-2": align === "right",
          })}
        >
          <IsLoggedIn>
            <UserDropdown dropdownAlign={align === "left" ? "start" : "end"} />
          </IsLoggedIn>
        </div>
      </div>
    </div>
  );
};
